(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react-emotion', '../styles/typography', '../styles/typography/getVariantFromProps', '../styles/typography/getColorFromProps'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react-emotion'), require('../styles/typography'), require('../styles/typography/getVariantFromProps'), require('../styles/typography/getColorFromProps'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.reactEmotion, global.typography, global.getVariantFromProps, global.getColorFromProps);
    global.typography = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _reactEmotion, _typography, _getVariantFromProps, _getColorFromProps) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Headline2 = exports.Headline1 = exports.Display3 = exports.Display2 = exports.Display1 = exports.Note = exports.Paragraph = exports.Label = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

  var _getVariantFromProps2 = _interopRequireDefault(_getVariantFromProps);

  var _getColorFromProps2 = _interopRequireDefault(_getColorFromProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n  ', ';\n']);

  var Display1 = (0, _reactEmotion2.default)('h1')(_templateObject, _typography.display1, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Display2 = (0, _reactEmotion2.default)('h1')(_templateObject, _typography.display2, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Display3 = (0, _reactEmotion2.default)('h2')(_templateObject, _typography.display3, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Headline1 = (0, _reactEmotion2.default)('h3')(_templateObject, _typography.headline1, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Headline2 = (0, _reactEmotion2.default)('h4')(_templateObject, _typography.headline2, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Label = (0, _reactEmotion2.default)('span')(_templateObject, _typography.label, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Paragraph = (0, _reactEmotion2.default)('span')(_templateObject, _typography.paragraph, _getVariantFromProps2.default, _getColorFromProps2.default);
  var Note = (0, _reactEmotion2.default)('span')(_templateObject, _typography.note, _getVariantFromProps2.default, _getColorFromProps2.default);

  exports.Label = Label;
  exports.Paragraph = Paragraph;
  exports.Note = Note;
  exports.Display1 = Display1;
  exports.Display2 = Display2;
  exports.Display3 = Display3;
  exports.Headline1 = Headline1;
  exports.Headline2 = Headline2;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/typography.js
// module id = 85
// module chunks = 0